module.exports = __webpack_public_path__ + "img/report-1.feb3c6f9.jpg";